<div class="card">
    <div class="card-header">
        Geo Mapping
    </div>
    <div class="card-body">
        <div class="row m-1">
            <div class="col-md-4 px-1">
                <label class="Label">Latitude</label>
                <input name="latitude" [(ngModel)]="latitude" style="text-align: right;" type="number" class="form-control" />
            </div>
            <div class="col-md-4 px-1">
                <label class="Label">Longitude</label>
                <input name="longitude" type="number" style="text-align: right;" [(ngModel)]="longitude" class="form-control" />
            </div>
            <div class="col-md-4 px-1">
                <label class="Label">Accuracy</label>
                <input name="accuracy" type="number" style="text-align: right;" [(ngModel)]="Accuracy" class="form-control" />
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-4 px-1">
                <label class="Label">Altitude</label>
                <input name="altitude" type="number" style="text-align: right;" [(ngModel)]="Altitude" class="form-control" />
            </div>
            <div class="col-md-4 px-1">
                <label class="Label">Heading</label>
                <input name="heading" type="text" [(ngModel)]="Heading" class="form-control" />
            </div>
            <div class="col-md-4 px-1">
                <label class="Label">Radius</label>
                <input name="radius" type="number" style="text-align: right;" [(ngModel)]="Radius" class="form-control" />
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-2 px-1">
                <label class="Label">
                    <input type="checkbox" name="ismocked" [(ngModel)]="IsMocked" ngbCheckbox />
                    IsMocked
                </label>
            </div>
            <div class="col px-1">
                <button type="submit" (click)="openGoogleMaps()" class="btn btn-primary text-nowrap">
                    Locate</button>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
               
                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button class="btn btn-sm btn-primary" name="btn2" ><i
                        class="bi bi-save"> </i> Save </button>
            </div>
        </div>
    </div>
</div>